import Chart from 'chart.js';

$(function() {
  let viewsChart;
  let viewsElement = document.getElementById('views-chart');

  if (viewsElement) {
    $.ajax({
    	url: '/api/v1/charts/views',
    	method: 'GET',
      data: {
        number_of_days: $('#statistic_period_for_chart').val()
      },
    	success: function (data) {
        viewsChart = new Chart(viewsElement, {
          type: 'line',
          data: {
            labels: data.labels,
            datasets: [{
                label: 'Views',
                fill: false,
                backgroundColor: 'rgb(54, 162, 235)',
                borderColor: 'rgb(54, 162, 235)',
                data: data.views
              },
              {
                label: 'Previous period views',
                fill: false,
                backgroundColor: 'rgb(54, 162, 235)',
                borderColor: 'rgb(54, 162, 235)',
                borderDash: [5, 5],
                data: data.previous_period_views
              }
            ]
          },
          options: {
            legend: {
              position: 'bottom'
            },
            tooltips: {
              mode: 'index',
              intersect: false
            },
            scales: {
              yAxes: [{
                ticks: {
                  beginAtZero: true,
                  precision: 0
                }
              }]
            }
          }
        });

        $('#statistic_period_for_chart').on('change', function () {
          let $self = $(this);
          $.ajax({
            url: '/api/v1/charts/views',
            method: 'GET',
            data: {
              number_of_days: $self.val()
            },
            success: function (data) {
              viewsChart.data.labels = data.labels
              viewsChart.data.datasets[0].data = data.views
              viewsChart.data.datasets[1].data = data.previous_period_views
              viewsChart.update();
            }
          });
        });
    	}
    });
  }
});


// WEBPACK FOOTER //
// ./app/webpacker/src/js/charts/views.js